import axios from 'axios';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { Button, Modal, Form } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from "../../../Loader.jsx";

const AdminQuotingRequest = (props) => {
  const { handleSubmit, reset, control, formState: { errors }, register } = useForm({ defaultValues: { rate: null, displayRate: null, expireDate: new Date() } });
  const [loader, setLoader] = useState(false);
  const token = useSelector((state) => state.token);
  const submitQuotation = (data) => {
    setLoader(true);
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/quotation/conform/${props?.quotationId}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      data: JSON.stringify({
        rate: data.rate,
        expireDate: data.expireDate,
        displayRate: data.displayRate
      }),
    }).then(res => {
      setLoader(false);
      toast(res.data.message || "Quotation is submit successfully", {
        theme: "light",
        position: "top-right",
        type: "success"
      })
      reset();
      props.getData();
      props.onHide();
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg, {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      } else {
        toast(err?.response?.data?.errors || err.message || "Failed to submit quotation", {
          theme: "light",
          position: "top-right",
          type: "error"
        })
      }
    });
  }

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Form onSubmit={handleSubmit(submitQuotation)}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Respond User Quotation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="Amounttosend">
              <Form.Label>Rate <span>*</span></Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter rate"
                {...register("rate", {
                  required: { message: "Rate is required", value: true },
                  pattern: { message: "Rate is not valid", value: /^[0-9]*\.?[0-9]{0,10}$/ }
                })} />
              {errors.rate ? <p className='errMsg'>{errors.rate.message}</p> : null}
            </Form.Group>

            {props.currency === "ngn" ?
              <Form.Group className="mb-3" controlId="Amounttosend">
                <Form.Label>Display rate <span>*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter display rate"
                  {...register("displayRate", {
                    required: { message: "Display rate is required", value: true },
                    pattern: { message: "Display rate is not valid", value: /^[0-9]*\.?[0-9]{0,10}$/ }
                  })} />
                {errors.displayRate ? <p className='errMsg'>{errors.displayRate.message}</p> : null}
              </Form.Group>
              : null}

            <Form.Group className="mb-3" controlId="currency">
              <Form.Label className='d-block'>Expire Date <span>*</span></Form.Label>
              <Controller
                name='expireDate'
                control={control}
                rules={{
                  required: { message: "Expire date required", value: true },
                  validate: {
                    date: (value) => new Date(value) > new Date() || 'Expire date is not valid'
                  }
                }}
                render={({ field }) => {
                  return (
                    <DatePicker
                      className='form-control'
                      minDate={new Date()}
                      selected={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      showTimeSelect
                      dateFormat="dd/mm/yyyy h:mm aa" />
                  );
                }} />
              {errors.expireDate ? <p className='errMsg'>{errors.expireDate.message}</p> : null}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleSubmit(submitQuotation)} className="button yellow" variant="primary" type="submit"> Submit </Button>
          </Modal.Footer>
        </Form >
      </Modal>
      <Loader show={loader} />
    </>
  )
}

export default AdminQuotingRequest